import { ServicesService } from 'src/app/services/services.service';
import { UtilsService, DrawableType } from './../../services/utils.service';
import { ErrorResponse } from './../../models/error.model';
import { OfficesService } from './../../services/offices.service';
import { DataTableColumn } from './../../components/generics/data-table/data-table.component';
import { Office } from './../../models/office.model';
import { Service, ServiceConfiguration } from './../../models/service.model';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-service-update-dialog',
    templateUrl: './service-update-dialog.component.html',
    styleUrls: ['./service-update-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ServiceUpdateDialogComponent implements OnInit {

    offices: Office[];
    selectedOffices: Office[] = [];

    columns: DataTableColumn[] = [
        { name: 'Oficina', prop: 'nombre' },
        { name: 'Sucursal', prop: 'sucursal' },
        { name: 'Pricing', parseValue: (office: Office) => this.getColumnShowValue(office, 'pricing', 'number-4') },
        { name: 'Porcentaje', parseValue: (office: Office) => this.getColumnShowValue(office, 'porcentaje', 'percent') },
        { name: 'Tope máximo', parseValue: (office: Office) => this.getColumnShowValue(office, 'topeMaximo', 'money') },
        { name: 'Tope mínimo', parseValue: (office: Office) => this.getColumnShowValue(office, 'topeMinimo', 'money') },
        { name: 'Descuento contado', parseValue: (office: Office) => this.getColumnShowValue(office, 'descuentoContado', 'percent') },
        { name: 'Descuento financiado', parseValue: (office: Office) => this.getColumnShowValue(office, 'descuentoFinanciado', 'percent') },
    ];

    constructor(
        private servicesService: ServicesService,
        private officesService: OfficesService,
        public dialogRef: MatDialogRef<ServiceUpdateDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public updatingService: Service,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {

        this.officesService.getOfficesUsingService(this.updatingService.id).subscribe(
            offices => this.offices = offices,
            (error: ErrorResponse) => this.utilsService.alert('Error al obtener oficinas', error.error?.descripcion)
        );
    }

    getColumnShowValue(office: Office, field: keyof ServiceConfiguration, type: DrawableType) {
        const oldValue = this.getServiceConfiguration(office)[field];
        const newValue = this.updatingService[field + 'Default'];
        if (this.selectedOffices.includes(office)) {
            let value = '';
            value += `<span class="deleted-value">${this.utilsService.parseByType(oldValue, type)}</span>`;
            value += `<span class="setted-value">${this.utilsService.parseByType(newValue, type)}</span>`;
            return value;
        } else {
            return this.utilsService.parseByType(oldValue, type);
        }
    }

    getServiceConfiguration(office: Office) {
        return office.servicios?.find(serviceConfig => serviceConfig.servicio?.id === this.updatingService.id);
    }

    cerrarDialogo() {
        this.dialogRef.close();
    }

    saveChanges() {
        this.servicesService.updateMultipleServiceConfigurations(
            this.selectedOffices.map(office => office.id),
            this.updatingService.id,
            this.updatingService.pricingDefault,
            this.updatingService.porcentajeDefault,
            this.updatingService.topeMaximoDefault,
            this.updatingService.topeMinimoDefault,
            this.updatingService.descuentoContadoDefault,
            this.updatingService.descuentoFinanciadoDefault,
        ).subscribe(
            _ => this.cerrarDialogo(),
            (error: ErrorResponse) => this.utilsService.alert('Error al actualizar oficinas', error.error?.descripcion)
        );
    }

    rowId = (row: Office) => row.id;

}
